import React from 'react';
import { Dropdown } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';

import { IconLanguage } from '@bynder/icons';
import { LanguageMenuItems } from './LanguageMenuItems';

export function LanguageMenu() {
	const { translate } = useTranslate();

	return (
		<Dropdown.Item submenu={<LanguageMenuItems />} icon={<IconLanguage />}>
			{translate('generalLanguage')}
		</Dropdown.Item>
	);
}
